import { styled } from '@mui/material/styles';
import { Box } from 'components/ui';

export const AuthDividerRoot = styled(Box)({
  paddingBottom: '9px',
  paddingTop: '9px',
  width: '100%',
});
